import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "./AxiosConfiguration";
import { APIURL } from "../Common/APIURL";

export const MP_InitiateMP = createAsyncThunk(
  "MeasurementProtocol/InitiateMP",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "post",
        `${APIURL}MeasurementProtocol/InitiateMP?projectID=${payload?.projectID}&facilityID=${payload?.facilityID}&testTypeID=${payload?.testTypeID}&createdBy=${payload?.createdBy}&companyID=${payload?.companyID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_GetProjectList = createAsyncThunk(
  "mp/GetProjectList",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetProjectList?companyId=${data?.companyID}&testTypeID=${data?.selectedTestType}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_GetMPList = createAsyncThunk(
  "mp/GetMPList",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetMPList?companyId=${data?.companyID}&facilityID=${data?.facilityID}&testTypeID=${data?.testTypeID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_GetGetMeasurementListbyID = createAsyncThunk(
  "mp/GetGetMeasurementListbyID",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetGetMeasurementListbyID?companyId=${data?.companyID}&facilityID=${data?.facilityID}&testTypeID=${data?.testTypeID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_SaveTestInfo = createAsyncThunk(
  "mp/saveTestInfo",
  async (data) =>
    await apiRequest("POST", "MeasurementProtocol/SaveTestInfo", data),
);

export const MP_GetTestInfoDetails = createAsyncThunk(
  "mp/GetTestInfoDetails",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetTestInfoDetails?companyId=${data?.companyID}&mpID=${data?.mpID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_SaveSaveMeasurementChain = createAsyncThunk(
  "mp/SaveSaveMeasurementChain",
  async (data) =>
    await apiRequest(
      "POST",
      "MeasurementProtocol/SaveSaveMeasurementChain",
      data,
    ),
);

export const MP_MeasurementChainDetails = createAsyncThunk(
  "mp/GetMeasurementChainDetails",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetMeasurementChainDetails?companyId=${data?.companyID}&mpID=${data?.mpID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_DeleteMPDetails = createAsyncThunk(
  "mp/DeleteMPDetails",
  async (data) =>
    await apiRequest(
      "POST",
      `MeasurementProtocol/DeleteMPDetails?id=${data?.id}&code=${data?.code}&modifiedBy=${data?.modifiedBy}`,
    ),
);

export const MP_GetInstrumentList = createAsyncThunk(
  "mp/GetInstrumentList",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetInstrumentList?companyId=${data?.companyID}&mpID=${data?.mpID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_SaveDUTChain = createAsyncThunk(
  "mp/SaveDUTChain",
  async (data) =>
    await apiRequest("POST", "MeasurementProtocol/SaveDUTChain", data),
);

export const MP_GetDUTChainDetails = createAsyncThunk(
  "mp/GetDUTChainDetails",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetDUTChainDetails?companyId=${data?.companyID}&mpID=${data?.mpID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_GetQuestionariesByID = createAsyncThunk(
  "mp/GetQuestionariesByID",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetQuestionariesByID?mpid=${data?.mpid}&companyID=${data?.companyID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_SaveQuestionaires = createAsyncThunk(
  "mp/SaveQuestionaires",
  async (data) =>
    await apiRequest("POST", "MeasurementProtocol/SaveQuestionaires", data),
);

export const MP_SaveCommunication = createAsyncThunk(
  "mp/SaveCommunication",
  async (data) =>
    await apiRequest("POST", "MeasurementProtocol/SaveCommunication", data),
);

export const MP_GetCommunicationChainDetails = createAsyncThunk(
  "mp/GetCommunicationChainDetails",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetCommunicationChainDetails?mpid=${data?.mpid}&companyID=${data?.companyID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_MPSubmitAll = createAsyncThunk(
  "mp/MPSubmitAll",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/MPSubmitAll?mpid=${data?.mpid}&modifiedBy=${data?.modifiedBy}&companyID=${data?.companyID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_GetApprovalMPList = createAsyncThunk(
  "mp/GetApprovalMPList",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/GetApprovalMPList?companyID=${data?.companyID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_MPApprovalResponce = createAsyncThunk(
  "mp/MPApprovalResponce",
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}MeasurementProtocol/MPApprovalResponce?mpID=${data?.mpID}&status=${data?.status}&modifiedBy=${data?.modifiedBy}&companyID=${data?.companyID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const MP_CreateDuplicateMP = createAsyncThunk(
  "MeasurementProtocol/CreateDuplicateMP",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "post",
        `${APIURL}MeasurementProtocol/CreateDuplicateMP?mpID=${payload?.mpID}&modifiedBy=${payload?.modifiedBy}&companyID=${payload?.companyID}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);
